(function ($) {


    /**
     * close all internal videos inside of remodals
     */
    var closeInternalVideos = function() {
        var $remodalInternalVideos = $('.remodal-wrapper.remodal-is-closed video');
        $remodalInternalVideos.each(function() {
            this.pause();
        });

        var $remodalIframes = $('.remodal-wrapper iframe');
        $remodalIframes.each(function() {
            $(this).attr('src', $(this).attr('src'));
        });
    };


    /**
     * if remodal: closed is triggered
     * handle specific tasks
     */
    $(document).on('closed', '.remodal', function (e) {
        closeInternalVideos();
    });

})(jQuery);
